import * as Types from '../../graphql/types'

import { gql } from 'apollo-boost'
import * as ApolloReactCommon from '@apollo/react-common'
import * as ApolloReactHooks from '@apollo/react-hooks'
const defaultOptions = {}
export type LetterRequestsForCustomerQueryVariables = Types.Exact<{
  customerId: Types.Scalars['Int']
}>

export type LetterRequestsForCustomerQuery = {
  __typename?: 'Query'
  letterRequestsForCustomer: {
    __typename?: 'LetterRequestForCustomer'
    letterDocumentIds: Array<number>
    letterAllowance?: {
      __typename?: 'LetterAllowance'
      canRequestLetter: boolean
      displayValue: string
    } | null
    openLetterRequest?: {
      __typename?: 'LetterRequest'
      id: number
      createdAt: any
      letterRequestId: number
    } | null
  }
}

export const LetterRequestsForCustomerDocument = gql`
  query LetterRequestsForCustomer($customerId: Int!) {
    letterRequestsForCustomer(customerId: $customerId) {
      letterDocumentIds
      letterAllowance {
        canRequestLetter
        displayValue
      }
      openLetterRequest {
        id
        createdAt
        letterRequestId
      }
    }
  }
`
export function useLetterRequestsForCustomerQuery(
  baseOptions: ApolloReactHooks.QueryHookOptions<
    LetterRequestsForCustomerQuery,
    LetterRequestsForCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useQuery<
    LetterRequestsForCustomerQuery,
    LetterRequestsForCustomerQueryVariables
  >(LetterRequestsForCustomerDocument, options)
}
export function useLetterRequestsForCustomerLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    LetterRequestsForCustomerQuery,
    LetterRequestsForCustomerQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions }
  return ApolloReactHooks.useLazyQuery<
    LetterRequestsForCustomerQuery,
    LetterRequestsForCustomerQueryVariables
  >(LetterRequestsForCustomerDocument, options)
}
export type LetterRequestsForCustomerQueryHookResult = ReturnType<
  typeof useLetterRequestsForCustomerQuery
>
export type LetterRequestsForCustomerLazyQueryHookResult = ReturnType<
  typeof useLetterRequestsForCustomerLazyQuery
>
export type LetterRequestsForCustomerQueryResult = ApolloReactCommon.QueryResult<
  LetterRequestsForCustomerQuery,
  LetterRequestsForCustomerQueryVariables
>
export function refetchLetterRequestsForCustomerQuery(
  variables?: LetterRequestsForCustomerQueryVariables
) {
  return { query: LetterRequestsForCustomerDocument, variables: variables }
}
